import React from "react";
import { IUserApiClient } from "../clients/userApiClient"
import { useInjection } from "../di/ioc-provider"
import { TYPES } from "../di/types"
import { LoadButton } from "./loadButton";
import { useTranslation } from "react-i18next";
import { UserStore } from "../stores/AuthStore";
import octopusLogo from "../assets/ocotpus.jpg"
import { Button } from "@mui/material";
import { ConnectedApp } from "../clients/dossierApiClient";

export interface IOctopusLink {
    children?: any
}

export const OctopusLink = (props: IOctopusLink) => {


    const _userClient = useInjection<IUserApiClient>(TYPES.IUserClient);
    const [loading, setLoading] = React.useState(false);
    const [t] = useTranslation("common");
    const userDetail = UserStore.useState(w => w.user);

    React.useEffect(() => {

    }, [userDetail])

    const fetchAuthLink = () => {

        setLoading(true);
        _userClient.getAuthenticateUrl(ConnectedApp.Octopus).takeAtLeast(500).then((res) => {
            window.open(res.data, "_blank", "noreferrer");
        }).finally(() => {
            setLoading(false);
        })
    }

    return <>
        {userDetail == undefined ? <></> : <>
            {userDetail.installedOctopus && userDetail.installationOctopusValid ? <>{props.children}</> : <>
                <Button disabled={loading} style={{ color: "#0951a4" }} onClick={() => { fetchAuthLink() }} startIcon={<img src={octopusLogo}></img>}>{t("general.linkWithOctopus")}</Button>
            </>}

        </>}
    </>
}